import React from 'react';
import { Button, Form, Select } from 'antd';
import { ArrowDownIcon, TimerIcon } from 'icons';
import { useTranslations } from 'next-intl';

import { IOlympicList, useOlympicCourse, useOlympicOrder } from 'modules/online-olympic';

import TimerBox from '../timer-box';

interface IProps {
  olympic?: IOlympicList;
}

const { useForm, useWatch } = Form;

const FixedSubjects: React.FC<IProps> = ({ olympic }) => {
  const t = useTranslations();
  const [form] = useForm();
  const { olympicCourse, isLoading } = useOlympicCourse();
  const { mutate, isLoading: isOrdering } = useOlympicOrder();
  const selectedCourseId = useWatch('olympicCourseId', form);

  const selectedCourse = olympicCourse?.find(course => course.id === selectedCourseId);

  const onFinish = (values: { olympicCourseId?: number }) => {
    mutate(values);
  };

  return (
    <div className="h-full w-full rounded-xl bg-white p-4 sm:m-3 sm:mx-0">
      <div className="flex items-center justify-between">
        <div className="inline rounded-lg bg-blue-50 p-2 text-sm font-medium text-blue-500">{olympic?.name}</div>
      </div>
      {!olympic?.already_participated ? (
        <Form form={form} onFinish={onFinish}>
          <Form.Item
            layout="vertical"
            label={<label className="!text-md mb-0 block text-gray-800">{t('fanlar_majmuasi')}</label>}
            name="olympicCourseId"
            className="!mb-13 !mt-5"
          >
            <Select
              suffixIcon={<ArrowDownIcon />}
              allowClear
              disabled={olympic?.already_participated}
              placeholder={t('Fan')}
              loading={isLoading}
              options={
                olympicCourse?.map(d => ({
                  value: d.id,
                  label: d.name
                })) || []
              }
            />
          </Form.Item>
          {selectedCourse && (
            <div className=" flex items-center justify-between">
              <div className="flex items-center gap-1 font-semibold">
                <div className="text-indigo-600">
                  <TimerIcon />
                </div>
                {selectedCourse?.duration} {t('daqiqa')}
              </div>
              <Button
                loading={isOrdering}
                htmlType="submit"
                className="!rounded-lg !border-transparent !bg-green-500 !py-4 !text-white disabled:!bg-gray-100 disabled:!text-gray-400"
              >
                {t('boshlash')}
              </Button>
            </div>
          )}
        </Form>
      ) : null}
      <div className="mt-4">
        {olympic?.already_participated ? (
          <p className="text-sm text-gray-600">
            {t(
              'siz_allaqachon_ushbu_olimpiadada_qatnashgansiz_iltimos_natijalarni_korish_uchun_olimpiada_tugashini_kuting'
            )}
          </p>
        ) : null}
        <TimerBox status={olympic?.status} time={olympic?.end_time} />
      </div>
    </div>
  );
};

export default FixedSubjects;
